// eslint-disable-next-line import/prefer-default-export
export var validateSource = source => {
  if (typeof window === 'undefined' || !window.XMLHttpRequest) return;
  var request = new XMLHttpRequest();

  // eslint-disable-next-line consistent-return
  return new Promise(resolve => {
    request.onreadystatechange = () => {
      if (request.readyState !== 4) return;
      if (request.status === 200 || request.status === 206 || request.status === 302) {
        resolve(true);
      } else {
        resolve(false);
      }
    };
    // confirm URL is valid without loading the content
    request.open('HEAD', source);
    request.send();
  });
};